"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MediaCarousel = void 0;
const react_1 = __importStar(require("react"));
const canvas_box_1 = require("../canvas-box");
const carousel_1 = require("../carousel");
const modal_1 = require("../modal");
const styles_1 = require("./styles");
const view_1 = require("./view");
const MediaCarousel = (_a) => {
    var { title, slidesPerPage = 4, itemBorderRadius = '10px', itemBoxShadow, isMobile = false } = _a, props = __rest(_a, ["title", "slidesPerPage", "itemBorderRadius", "itemBoxShadow", "isMobile"]);
    const [isModalOpen, setIsModalOpen] = (0, react_1.useState)(false);
    const [carouselIndex, setCarouselIndex] = (0, react_1.useState)(0);
    const handleOnClick = (idx) => {
        setCarouselIndex(idx);
        setIsModalOpen(true);
    };
    const mediaElements = (0, react_1.useMemo)(() => {
        var _a;
        const videoElements = [];
        const userGeneratedVideoElements = [];
        (_a = props === null || props === void 0 ? void 0 : props.videos) === null || _a === void 0 ? void 0 : _a.forEach((video) => {
            const videoElement = {
                title: video.videoTitle,
                imageSrcUrl: video.slateImageUrl,
                isVideoElement: true,
                mediaSrcUrl: video.mediaSrcUrl
            };
            if (video.isUserGeneratedVideo) {
                userGeneratedVideoElements.push(videoElement);
            }
            else {
                videoElements.push(videoElement);
            }
        });
        const imageElements = (props === null || props === void 0 ? void 0 : props.images)
            ? props.images.map((url) => ({
                imageSrcUrl: url,
                title: props.imageAltText || ''
            }))
            : [];
        return [...videoElements, ...imageElements, ...userGeneratedVideoElements];
    }, []);
    const carouselElements = (0, react_1.useMemo)(() => {
        return isMobile
            ? (0, view_1.getMobileCarouselElements)({ medias: mediaElements, itemBoxShadow, itemBorderRadius, handleOnClick })
            : (0, view_1.getCarouselElements)({
                medias: mediaElements,
                itemBoxShadow,
                itemBorderRadius,
                handleOnClick
            });
    }, []);
    const modalElements = (0, react_1.useMemo)(() => {
        return (0, view_1.getModalCarouselElements)({ medias: mediaElements, itemBorderRadius });
    }, []);
    const handleCloseModal = () => {
        setIsModalOpen(false);
    };
    return carouselElements && carouselElements.length > 0 ? (react_1.default.createElement(react_1.default.Fragment, null,
        !isMobile && (react_1.default.createElement(styles_1.StyledTitleContainer, null,
            react_1.default.createElement("h2", { "data-cy": 'media-carousel-title' }, title))),
        react_1.default.createElement(canvas_box_1.CanvasContainer, { padding: isMobile ? '' : '0px 30px', "data-cy": "media-carousel-container", style: { maxHeight: '100%' } },
            react_1.default.createElement(carousel_1.Carousel, { circularPaging: true, imageMargins: '10px', leftPaginationButtonDistance: '-30px', rightPaginationButtonDistance: '-30px', slidesPerPage: slidesPerPage, showPaginationButtons: isMobile ? false : true, showPaginationDots: isMobile, elements: carouselElements, allowScrolling: true }),
            react_1.default.createElement(modal_1.Modal, { "data-cy": 'media-carousel-modal', isOpen: isModalOpen, close: handleCloseModal, hasCloseButton: true },
                react_1.default.createElement(styles_1.ModalCarouselContainer, null,
                    react_1.default.createElement(carousel_1.Carousel, { circularPaging: true, imageMargins: '25px', leftPaginationButtonDistance: '-60px', rightPaginationButtonDistance: '-60px', slidesPerPage: 1, initialFocusSlideIndex: carouselIndex, "data-cy": 'media-carousel-modal-carousel', elements: modalElements })))))) : null;
};
exports.MediaCarousel = MediaCarousel;
